import { Modal } from '@cognite/cogs.js-v10';
import styled from 'styled-components';

export const AssignmentModal = styled(Modal)`
  // need to set overflow visible to make dropdown work inside modal
  overflow: visible !important;
  top: 115px !important;
`;
